import i18n from "../../../i18n"
export const professors = {
    department: i18n.t("bso_department"),
    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1871/2218-Tsimpiridou_ed-2.jpg',
                fname: i18n.t('fotini'),
                lname: i18n.t('tsibiridou'),
                title: i18n.t('proedrosTmimatos'),
                tel: '2310 891.426',
                email: 'ft@uom.edu.gr',
                building: 'ΚΖ',
                office: '233'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1877/4104-Kostis_fin-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('tsitselikis'),
                title: i18n.t('Κοσμήτορας'),
                tel: '2310 891.540',
                email: 'kt@uom.edu.gr',
                building: 'ΚΖ',
                office: '234'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('eleni'),
                lname: i18n.t('gavra'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.458',
                email: 'egavra@uom.edu.gr',
                building: 'ΚΖ',
                office: '225'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1874/1211-sd-2.jpg',
                fname: i18n.t('sofia'),
                lname: i18n.t('delipalla'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.468',
                email: 'sd@uom.edu.gr',
                building: 'ΚΖ2',
                office: '230'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/6143/5641-aleka_s-2.jpg',
                fname: i18n.t('alexandra'),
                lname: i18n.t('ioannidou'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.733',
                email: 'ai@uom.edu.gr',
                building: 'ΓΔ',
                office: '415'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('kiriakos'),
                lname: i18n.t('kentrotis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.797',
                email: 'kkentrotis@uom.edu.gr',
                building: 'ΓΔ3',
                office: '301'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('thanasis'),
                lname: i18n.t('koulakiotis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.457',
                email: 'akoulak@uom.edu.gr',
                building: 'ΚΖ',
                office: '432'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1872/1680-kyrkilis-2.jpg',
                fname: i18n.t('dimitrios'),
                lname: i18n.t('kirkilis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.429',
                email: 'kyrkilis@uom.edu.gr',
                building: 'ΚΖ2',
                office: '226'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1906/4888-Marangos_2-2.jpg',
                fname: i18n.t('john'),
                lname: i18n.t('marangos'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.712',
                email: 'marangos@uom.edu.gr',
                building: 'ΓΔ',
                office: 'Γ203'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1867/4866-Marantzidis_2-2.jpg',
                fname: i18n.t('nikolaos'),
                lname: i18n.t('marantzidis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.467',
                email: 'nikosm@uom.edu.gr',
                building: 'ΚΖ2',
                office: '231'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1892/1202-knichoritis-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('nihoritis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.762',
                email: 'knichoritis@uom.edu.gr',
                building: 'ΓΔ',
                office: '210'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1870/4831-Papapanagos-ed-2.jpg',
                fname: i18n.t('harry'),
                lname: i18n.t('papapanagos'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.471',
                email: 'hp@uom.edu.gr',
                building: 'ΚΖ2',
                office: '227'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('christos'),
                lname: i18n.t('paraskevopoulos'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.419',
                email: 'chrp@uom.edu.gr',
                building: 'ΚΖ',
                office: '234Γ'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1893/3049-Sarri2-2.jpg',
                fname: i18n.t('aikaterini'),
                lname: i18n.t('sarri'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.349',
                email: 'ksarri@uom.edu.gr',
                building: 'ΚΖ',
                office: '221Α'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('fotios'),
                lname: i18n.t('siokis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.459',
                email: 'fsiokis@uom.edu.gr',
                building: 'ΚΖ',
                office: '200'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('dimitrios'),
                lname: i18n.t('stamatopoulos'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.472',
                email: 'ds@uom.edu.gr',
                building: 'ΚΖ2',
                office: '228'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1868/1768-tzionasN-2.jpg',
                fname: 'ioannis',
                lname: 'tzionas',
                title: 'kathigitis',
                tel: '2310 891.470',
                email: 'iat@uom.edu.gr',
                building: 'ΚΖ2',
                office: '232'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1894/12625-12556-AKRIVOULIS2-2-2.jpg',
                fname: 'dimitrios',
                lname: 'akrivoulis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.775',
                email: 'diakrivoulis@uom.edu.gr',
                building: 'ΓΔ',
                office: '301Α'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1895/4900-VVlasidis-2.jpg',
                fname: i18n.t('vlasios'),
                lname: i18n.t('vlasidis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.318',
                email: 'vvlasidis@uom.edu.gr',
                building: 'ΚΖ',
                office: '212'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'nikolaos',
                lname: 'zaikos',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.713',
                email: 'nzaikos@uom.edu.gr',
                building: 'ΚΖ',
                office: 'Κ232Β'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'emmanouil',
                lname: 'karagiannis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.425',
                email: 'makara@uom.edu.gr',
                building: 'ΚΖ',
                office: '235'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1889/4881-Karpetis-2.jpg',
                fname: i18n.t('christos'),
                lname: i18n.t('karpetis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.482',
                email: 'ckarpet@uom.edu.gr',
                building: 'ΚΖ',
                office: '222'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1898/5835-s340manos-2.jpg',
                fname: 'ioannis',
                lname: 'manos',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.626',
                email: 'imanos@uom.edu.gr',
                building: 'ΓΔ',
                office: '301Α'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1902/4511-Mavrogeni_fotoprofil_071019-2.jpg',
                fname: 'stavroula',
                lname: 'mavrogeni',
                title: 'Αναπληρώτρια Καθηγήτρια',
                tel: '2310 891.450',
                email: 'smavroge@uom.edu.gr',
                building: 'ΚΖ',
                office: '223'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'panagiotis',
                lname: 'michailidis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.436',
                email: 'pmichailidis@uom.edu.gr',
                building: 'ΚΖ',
                office: '235'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('anastasios'),
                lname: i18n.t('panopoulos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.157',
                email: 'apanopoulos@uom.edu.gr',
                building: 'ΚΖ',
                office: '235'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1905/5019-Soutsiou-2.jpg',
                fname: 'tsiprian',
                lname: 'soutsiou',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.475',
                email: 'sciprian@uom.edu.gr',
                building: 'ΚΖ1',
                office: '212'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'georgios',
                lname: 'christidis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.460',
                email: 'gxristidis@uom.edu.gr',
                building: 'ΚΖ2',
                office: '234Β'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'stratos',
                lname: 'dordanas',
                title: 'epikourosKathigitis',
                tel: '2310 891.638',
                email: 'dordanas@uom.edu.gr',
                building: 'ΚΖ2',
                office: '223'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/10607/11290-Karak_photo-2.jpg',
                fname: i18n.t('leonidas'),
                lname: i18n.t('karakatsanis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.888',
                email: 'lkarak@uom.edu.gr',
                building: 'ΚΖ',
                office: '234Δ'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('nikolaos'),
                lname: i18n.t('liazos'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.481',
                email: 'nliazos@uom.edu.gr',
                building: 'ΓΔ',
                office: '415'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/6786/12557-sideri22222-2.jpg',
                fname: i18n.t('eleni'),
                lname: i18n.t('sideri'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.439',
                email: 'elasideri@uom.edu.gr',
                building: 'ΚΖ',
                office: '221'
            }
        ]
}